// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../node_modules/rescript/lib/es6/list.js";
import * as Json_decode from "../../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";

function decodeVehicleTypes(json) {
  return {
          vehicle_id: Json_decode.field("vehicle_id", Json_decode.$$int, json),
          type_: Json_decode.field("type", Json_decode.string, json),
          name: Json_decode.field("name", Json_decode.string, json)
        };
}

function apiModelToState(vehicles) {
  return List.map((function (v) {
                return {
                        vehicle_id: v.vehicle_id,
                        vehicle: {
                          vehicle_type: v.type_,
                          display_name: v.name
                        }
                      };
              }), vehicles);
}

function builder(json) {
  return apiModelToState(Json_decode.field("vehicle_types", (function (param) {
                    return Json_decode.list(decodeVehicleTypes, param);
                  }), json));
}

export {
  decodeVehicleTypes ,
  apiModelToState ,
  builder ,
  
}
/* No side effect */
